import { useCallback, useState } from 'react';

import { IAdminUser } from '../../models/auth/signIn.model';
import { SuccessHttpResponse } from '../../models/https';
import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';
import useHttps from '../useHttps';

const useAdminProfile = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onSuccess = ({ data }: SuccessHttpResponse<IAdminUser>) => {
    dispatch(authActions.setAdminProfile(data));
  };

  const fetchProfile = useCallback(() => {
    request({ url: 'api/v1/admin/me', method: 'get' }, onSuccess, setLoading);
    // eslint-disable-next-line
  }, []);

  return { fetchProfile, loading };
};

export default useAdminProfile;
